import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Banner } from './banner';
import { SanitizedMarkdown } from './sanitized-markdown';
import { useSiteSettings } from './use-site-settings';
import { useLocalStorage } from '../hooks/use-local-storage';
/**
 * The banner an admin configures in the runtime settings, shown when the page settings
 * don't bring a banner of their own. A dismissal is remembered by the banner's dismiss
 * token, so correcting a typo doesn't show it to everyone again.
 */
export const RegistryBanner = () => {
    const { data: settings } = useSiteSettings();
    const [dismissed, setDismissed] = useLocalStorage('openvsx-banner-dismissed', null);
    // The registry leaves the banner keys out entirely while the banner is switched off. Values are
    // checked rather than trusted: the banner renders above every page, so a surprise from an
    // unknown registry must not be able to throw here.
    const enabled = settings?.bannerEnabled === true;
    const rawMessage = settings?.bannerMessage;
    const message = typeof rawMessage === 'string' ? rawMessage.trim() : '';
    const dismissId = settings?.bannerDismissId ?? '';
    const severity = settings?.bannerSeverity === 'warning' ? 'warning' : 'info';
    return (_jsx(Banner, { open: enabled && message.length > 0 && dismissed !== dismissId, showDismissButton: true, dismissButtonOnClick: () => setDismissed(dismissId), color: severity, children: _jsx(Box, { sx: { '& p': { my: 0 } }, children: _jsx(SanitizedMarkdown, { content: message, linkify: false }) }) }));
};
//# sourceMappingURL=registry-banner.js.map